import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PartyPopper } from 'lucide-react';
import { SocialProofBanner, LiveActivityFeed } from '../ConversionOptimizations';
import { ImpactStrip } from './ImpactStrip';

const API = process.env.REACT_APP_BACKEND_URL;
const MILESTONE_THRESHOLD = 500;
const MILESTONE_KEY = 'cfr_milestone_500_seen';

// Switches from simulated "FOMO" social proof to real, honest numbers automatically once
// the ministry's real member count crosses the honesty threshold used by ImpactStrip.
export const GrowthAwareSocialProof = ({ colors }) => {
  const [members, setMembers] = useState(null);
  const [justCrossed, setJustCrossed] = useState(false);

  useEffect(() => {
    fetch(`${API}/api/public/impact-stats`)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (!data) return;
        const count = data.members || 0;
        setMembers(count);
        if (count >= MILESTONE_THRESHOLD && !localStorage.getItem(MILESTONE_KEY)) {
          setJustCrossed(true);
          localStorage.setItem(MILESTONE_KEY, '1');
        }
      })
      .catch(() => {});
  }, []);

  const hasRealGrowth = members !== null && members >= MILESTONE_THRESHOLD;

  if (hasRealGrowth) {
    return (
      <div data-testid="growth-milestone-block">
        <AnimatePresence>
          {justCrossed && (
            <motion.div
              initial={{ opacity: 0, scale: 0.85, y: -10 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0 }}
              transition={{ type: 'spring', stiffness: 220, damping: 18 }}
              data-testid="milestone-celebration-banner"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.6rem',
                background: `linear-gradient(135deg, ${colors?.sage || '#789B73'} 0%, ${colors?.navy || '#1E3A8A'} 100%)`,
                color: 'white',
                padding: '0.75rem 1.5rem',
                borderRadius: '999px',
                margin: '0 auto 1rem',
                maxWidth: 'fit-content',
                fontWeight: 700,
                fontSize: '0.9rem',
                textAlign: 'center'
              }}
            >
              <PartyPopper size={18} />
              We just crossed {members.toLocaleString()}+ real people through the door — thank you for being part of that.
            </motion.div>
          )}
        </AnimatePresence>
        <ImpactStrip colors={colors} />
      </div>
    );
  }

  return (
    <div
      data-testid="fomo-social-proof-block"
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.75rem', marginTop: '2rem' }}
    >
      <SocialProofBanner />
      <LiveActivityFeed />
    </div>
  );
};
